module.exports = __webpack_public_path__ + "img/1-09.e71fd497.jpg";